<template>
  <component
    :is="comp"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot v-bind="$attrs" v-on="$listeners"></slot>
  </component>
</template>

<script>
export default {
  name: 'DynamicComponent',
  props: { componentName: { type: String, default: '' }, path: { type: String, default: '' } },
  computed: {
    comp () {
      const componentName = this.componentName;
      const path = this.path;

      if(componentName && path) return () => import(`@/components/${path}/${componentName}`);
      else return componentName
    }
  }
}
</script>
